import React, { FC, useState, useContext } from 'react';
import { CommonModal } from '../../../ui-library/components/modals/common-modal';
import { FormContainer } from '../../../ui-library/components/form-elements/FormContainer';
import { Formik } from 'formik';
import { ActionButton } from '../../../ui-library/components/buttons/action-button';
import { Stack } from '@mui/material';
import { RadioButtonSelect } from '../../../ui-library/components/form-elements/RadioButtonSelect';
import * as Yup from 'yup';
import { useStyles } from './styles';
import { FileUpload } from '../../../ui-library/components/form-elements/file-upload/FileUpload';
import { API_STATUS } from '../../common/constants/CommonConstants';
import { toast } from 'react-toastify';
import BackersManager from '../manager/BackersManager';
import { AuthContext } from '../../../contexts/authContext';

const BulkInviteBackerModal: FC<any> = ({
  title,
  openModal,
  handleClose,
  reInvite,
  selectedRows,
  handleSubmit,
  apiLoading,
  testActionType
}) => {
  const classes = useStyles();
  const authContext = useContext(AuthContext);
  const backersManager = new BackersManager(authContext);
  const initialValues = { file: undefined, mode_of_comm: 'email' };
  const validationSchema = Yup.object({
    file: Yup.mixed().required()
  });
  const [testApiStatus, setTestApiStatus] = useState(API_STATUS.SUCCESS);

  const sendTestEmailWhatsapp = async (data: any) => {
    try {
      setTestApiStatus(API_STATUS.LOADING);
      const response = await backersManager.sendTestEmailWhatsapp({
        "email": "{backer_email}",
        "inviteMsg": "This is a test message for bulk invite backers.",
        "medium": "email",
        "name": "{backer_name}",
        "type_of_investment_profile": "individual"
      }, testActionType, true);
      toast.success(response?.message);
      setTestApiStatus(API_STATUS.SUCCESS);
    } catch (e: any) {
      toast.error(e);
      setTestApiStatus(API_STATUS.SUCCESS);
    }
  };

  return (
    <CommonModal
      submitText="continue"
      isOpen={openModal}
      handleClose={handleClose}
      title={`${title} ${reInvite && selectedRows ? '(' + selectedRows?.length + ' backers selected)' : ''}`}
      hideButtons
    >
      <FormContainer>
        <Formik initialValues={initialValues} validationSchema={!reInvite && validationSchema} onSubmit={handleSubmit}>
          {(form) => (
            <Stack gap={2}>
              {!reInvite && (
                <FileUpload
                  accept={{ 'text/excel': ['.xltx', '.xls', '.xlsx', '.xlsb', '.xlsm'] }}
                  title="upload excel file (max size 2 MB)"
                  selectedFile={(file: any) => form.setFieldValue('file', file)}
                  value={form?.values?.file}
                  label="Upload excel sheet with backers details"
                  helperText="Note: backers who are already invited will not be sent any email"
                  error={!!form?.errors?.file}
                />
              )}
              {JSON.stringify(form?.errors.file)}
              <RadioButtonSelect
                fieldName="mode_of_comm"
                id="mode_of_comm"
                value={form?.values?.mode_of_comm}
                formLabel="Send Invite via Email?"
                options={[{ name: 'Email', value: 'email' }]}
              />

              <br />
              <Stack direction="row" gap={1} justifyContent="end">
                {testActionType && (
                  <ActionButton
                    disabled={testApiStatus === API_STATUS.LOADING}
                    isLoading={testApiStatus === API_STATUS.LOADING}
                    onClick={() => {
                      form.validateForm().then((errr) => {
                        if (Object.keys(errr)?.length) {
                          form.submitForm();
                        } else {
                          sendTestEmailWhatsapp(form.values);
                        }
                      });
                    }}
                  >
                    Send Test email
                  </ActionButton>
                )}
                <ActionButton onClick={form.handleSubmit} isLoading={apiLoading} disabled={apiLoading}>
                  Send Invite Email
                </ActionButton>
              </Stack>
            </Stack>
          )}
        </Formik>
      </FormContainer>
    </CommonModal>
  );
};

export default BulkInviteBackerModal;
